import { generateResourceReducer } from '../generators/resource.reducer';

import * as types from './payment.types';
import * as constants from './payment.constants';

export const paymentReducer = generateResourceReducer<types.IPayment>({
  STORE: constants.STORE_PAYMENT,
  CLEAR: constants.CLEAR_PAYMENT,
});
